export default {
	propose: 'Создайте собственное событие и продавайте\nбилеты онлайн c помощью сервиса teeko!',
	description: 'Непревзойденные впечатления\nначинаются с покупки билета!',
	moreEvents: 'Показать больше событий',
	search: 'Поиск'
}
